import { Cookie } from '@repo/tools'
import { getPasswordSettings } from './password-settings.service'

export const passwordSettingsOptions = (enabled: boolean) => ({
  queryKey: ['password-settings'],
  queryFn: getPasswordSettings,
  enabled: !!Cookie.get('access_token') && enabled,
})
